module.exports = __webpack_public_path__ + "static/media/haubold.1e5a06e8.jpg";